import styled from 'styled-components';

export const InputWithSuggestionsWrapper = styled.div`
    position: relative;
`;
